{
  "SymbolLabel": "Símbolo:",
  "SymbolNote": "(Aplica automaticamente as alterações aos campos abaixo)",
  "PatternLabel": "Padrão:",
  "GroupingseparatorLabel": "Separador de Agrupamento:",
  "GroupingseparatorOptionCommaDesc": "(Vírgula)",
  "GroupingseparatorOptionSpaceDesc": "(Espaço)",
  "GroupingseparatorOptionFullstopDesc": "(Ponto final)",
  "DecimalseparatorLabel": "Separador decimal:",
  "DecimalseparatorOptionFullstopDesc": "(Ponto final)",
  "DecimalseparatorOptionColonDesc": "(Cólon)",
  "DecimalseparatorOptionCommaDesc": "(Vírgula)",
  "PreviewLabel": "Visualizar",
  "CurrencyDisplayFormat_SectionHeader": "Formato de exibição de moeda",
  "NAME": "CurrencyDisplayFormat"
}